<template>
	<PropertyDialogSimpleStructureDoublePoint v-if="isDoublePoint" :modelValue="modelValue"
		:selectedStructureType="selectedStructureType" :initialTwoPoints="initialTwoPoints" :tempMeshId="tempMeshId"
		@confirm="$emit('confirm', $event)" @cancel="$emit('cancel')"
		@update:modelValue="$emit('update:modelValue', $event)" />
	<PropertyDialogSimpleStructureSinglePoint v-else :modelValue="modelValue"
		:selectedStructureType="selectedStructureType" :initialPosition="initialPosition" :tempMeshId="tempMeshId"
		@confirm="$emit('confirm', $event)" @cancel="$emit('cancel')"
		@update:modelValue="$emit('update:modelValue', $event)" />
</template>

<script>
import { SIMPLE_STRUCTURE_TYPE } from "@/models/objects/solidMesh/types";
import PropertyDialogSimpleStructureDoublePoint from "./PropertyDialogSimpleStructureDoublePoint.vue";
import PropertyDialogSimpleStructureSinglePoint from "./PropertyDialogSimpleStructureSinglePoint.vue";

export default {
	name: "PropertyDialogSimpleStructure",
	components: {
		PropertyDialogSimpleStructureSinglePoint,
		PropertyDialogSimpleStructureDoublePoint,
	},
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
		selectedStructureType: {
			type: String,
			default: null,
		},
		initialPosition: {
			type: Object,
			default: null,
		},
		/** Two-point initial coords — { p1: {x,y,z}, p2: {x,y,z} } */
		initialTwoPoints: {
			type: Object,
			default: null,
		},
		tempMeshId: {
			type: String,
			default: null,
		},
	},
	emits: ["confirm", "cancel", "update:modelValue"],
	computed: {
		isDoublePoint() {
			return (
				this.selectedStructureType === SIMPLE_STRUCTURE_TYPE.PIPE ||
				this.selectedStructureType === SIMPLE_STRUCTURE_TYPE.RETAINING_WALL
			);
		},
	},
};
</script>
